import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import { initializeLanguageFromBrowser } from './initializeLanguage';

const crypto = globalThis.crypto;
if (crypto && typeof crypto.randomUUID !== 'function') {
  const bytes = new Uint8Array(16);
  crypto.randomUUID = () => {
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
      .slice(6, 8)
      .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
  };
}

initializeLanguageFromBrowser();

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
